"use client";

import { X } from "@/components/icons";
import type { ReactNode } from "react";
import { IconButton } from "@/components/ui/icon-button";
import { cn } from "@/lib/utils";

export function ChipClearSpace() {
  return <span aria-hidden="true" className="ml-0.5 -mr-1 size-5 shrink-0" />;
}

export function ClearableChip({ children }: { children: ReactNode }) {
  return <span className="relative inline-flex shrink-0">{children}</span>;
}

export function ChipClearAction({
  label,
  onClear,
  className,
}: {
  label: string;
  onClear: () => void;
  className?: string;
}) {
  return (
    <IconButton
      size="inline"
      aria-label={`Clear ${label} filter`}
      onClick={onClear}
      className={cn("absolute top-1/2 -translate-y-1/2 animate-in fade-in-0 zoom-in-75 duration-150", className)}
    >
      <X />
    </IconButton>
  );
}
